module.exports = __webpack_public_path__ + "convite/assets/img/timbeta-logo.b57b6f28.png";